import { create } from 'zustand';

interface DemoPersistStore {
  message: string | null;
  showBlocked: (message: string) => void;
  clear: () => void;
}

let hideTimer: ReturnType<typeof setTimeout> | null = null;

export const useDemoPersistStore = create<DemoPersistStore>((set) => ({
  message: null,
  showBlocked: (message) => {
    if (hideTimer) clearTimeout(hideTimer);
    set({ message });
    hideTimer = setTimeout(() => {
      set({ message: null });
      hideTimer = null;
    }, 4500);
  },
  clear: () => {
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = null;
    set({ message: null });
  },
}));
